export default {
  title: 'Set up authentication via SMS',
  description: 'Enter your phone number',
};
